import { deleteCookie, getCookie, setCookie } from 'cookies-next';

export const AUTHORIZATION_COOKIE_NAME = 'ggCWBClient';

export const getJwtFromCookie = () => {
  let jwt = '';

  const cookie = getCookie(AUTHORIZATION_COOKIE_NAME);

  if (cookie) {
    jwt = cookie;
  }

  return jwt;
};

export const setJwtCookie = (jwt: string) => {
  setCookie(AUTHORIZATION_COOKIE_NAME, jwt, {
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
    httpOnly: false,
  });
};

export const removeJwtCookie = () => {
  deleteCookie(AUTHORIZATION_COOKIE_NAME);
};
